import { createSlice } from "@reduxjs/toolkit";
import {
  getAppVersions,
  createAppVersion,
  updateAppVersion,
  deleteAppVersion,
} from "./appVersions-operations";

const initialState = {
  items: [],
  total: 0,
  page: 1,
  totalPages: 1,
  isLoading: false,
  error: null,
};

const handlePending = (state) => {
  state.isLoading = true;
  state.error = null;
};

const handleRejected = (state, { payload }) => {
  state.isLoading = false;
  state.error = payload;
};

const appVersionsSlice = createSlice({
  name: "appVersions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAppVersions.pending, handlePending)
      .addCase(getAppVersions.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.items = payload.versions;
        state.total = payload.total;
        state.page = payload.page;
        state.totalPages = payload.totalPages;
      })
      .addCase(getAppVersions.rejected, handleRejected)
      
      .addCase(createAppVersion.pending, handlePending)
      .addCase(createAppVersion.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.items.unshift(payload.data);
        state.total += 1;
      })
      .addCase(createAppVersion.rejected, handleRejected)
      
      .addCase(updateAppVersion.pending, handlePending)
      .addCase(updateAppVersion.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const index = state.items.findIndex(
          (item) => item._id === payload.data._id
        );
        if (index !== -1) {
          state.items[index] = payload.data;
        }
      })
      .addCase(updateAppVersion.rejected, handleRejected)

      .addCase(deleteAppVersion.pending, handlePending)
      .addCase(deleteAppVersion.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const index = state.items.findIndex((item) => item._id === payload);
        if (index !== -1) {
          state.items[index].isActive = false; // М'яке видалення
        }
      })
      .addCase(deleteAppVersion.rejected, handleRejected);
  },
});

export default appVersionsSlice.reducer;
